import { render, staticRenderFns } from "./AcceleratorPhd.vue?vue&type=template&id=21a168f2&"
import script from "./AcceleratorPhd.vue?vue&type=script&lang=js&"
export * from "./AcceleratorPhd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports